import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { JoiEvent, LabelMaps, Venue } from 'globals/store/events.data';
import { Program, ProgramDay, ProgramLaneInitDayData, Session, SessionType } from 'globals/store/programs.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { getPropSizes, sleepForMS } from '../../helpers/helpers';
// TODO import { ConfirmProgramActionDialogComponent } from './program.dialog.confirmAction.component';
import { select } from '@ngrx/store';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { programsActions, programsFeature } from '../../store/programs.era';
import { createBarChart } from '../../components/nav-bar/event-bar-chart';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { LabelItemComponent } from 'src/app/components/label-marker/label-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { SessionCardComponent } from './session-card.component';
import { SecondaryTimezoneDayPipe, SecondaryTimezoneSessionPipe, TimeZonePipe } from 'src/app/services/pipes/timezone.pipe';
import { getOneStorePromise } from 'src/app/store/ui.era';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { MatButtonModule } from '@angular/material/button';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { jsonCopyObject } from 'globals/helpers/helpers';
import { ConfirmProgramActionDialogComponent } from './program.dialog.confirmAction.component';


@Component({
    selector: 'program-lane',
    animations: [
        trigger('drop', [
            state('collapse', style({ height: '0', padding: 0 })),
            transition('expanded <=> collapse', animate("300ms"))
        ])
    ],
    templateUrl: './program-lane.html',
    styleUrls: ['./program-lane.scss'],
    standalone: true,
    imports: [IconComponent,CdkDropList, CdkDrag, JoiInputComponent, MatButtonModule, SecondaryTimezoneDayPipe, ProgramDayDate, IdsToItemsPipe, CommonModule, LabelItemComponent, SecondaryTimezoneSessionPipe, MatMenuModule, SessionCardComponent, CdkDrag],
})
export class ProgramLaneComponent extends Wrapper<ProgramLaneComponent> implements AfterViewInit {
  @Input() lane: Program
  @Input() list: string[][]
  @Input() idx: number
  @Input() venue: Partial<Venue>
  @Input() fullAccess = false
  @Input() isLogistics = false
  @Input() labelMaps: LabelMaps
  @Input() wide: boolean
  @Input() showTimezones = false
  @Input() event: JoiEvent
  @Input() dragging: boolean
  @Input() draggedDay: number
  @Input() first: boolean
  @Input() canDrag = false
  
  justAddedSession = false
  
  _file: 'program-lane.component.ts'
  programDetailsState = 'collapse'
  @Output() programDeleted: EventEmitter<void> = new EventEmitter()
  @Output() programDuplicatedId: EventEmitter<string> = new EventEmitter()
  @Output() editProgram: EventEmitter<void> = new EventEmitter()
  @Output() editSession: EventEmitter<Session> = new EventEmitter()
  @Output() loading: EventEmitter<boolean> = new EventEmitter()
  @Output() showBarChart: EventEmitter<boolean> = new EventEmitter()

  @ViewChild('titleInput') titleInput: JoiInputComponent
  debugClicks = 0

  debugProgram() {
    this.debugClicks += 1
    if (this.debugClicks < 5) return
    this.debugClicks = 0
    this.showBarChart.emit()
  }

  async ngAfterViewInit() {
    
    if (!this.first) return
    const focusFirstProgram = await getOneStorePromise(this.store, select(programsFeature.selectFocusFirstProgram))
    
    if (focusFirstProgram) {
      this.titleInput.manualFocus()
      this.store.dispatch(programsActions.focusFirstProgram(false))
    }
  }


  updateProgramTitle(title) {
    const updatedProgram = JSON.parse(JSON.stringify(this.lane)) as Program
    updatedProgram.title = title
    this.eventService.setProgramName(this.lane.id, updatedProgram.title)
    this.programService.updateProgramTitle(updatedProgram)
  }

  public async deleteBreak(evt, session, idx) {
    const rect = evt.target.getBoundingClientRect()
    const data = { rect, title: 'Delete', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.lane.sessions[session.on_day - 1].sessions.splice(idx, 1)
    delete this.lane.sessions_obj[session.id]
    this.programService.upsertProgram(this.lane)
  }

  async updateStartTime(time: string, dayIdx: number) {
    const updatedProgram = JSON.parse(JSON.stringify(this.lane)) as Program
    updatedProgram.sessions[dayIdx].start = time
    this.programService.upsertProgram(updatedProgram);
  }

  async addDay() {
    const updatedProgram = this.programService.initDay(this.lane).program;
    await this.programService.upsertProgram(updatedProgram, {file:this._file, function:'addDay', data: {lane: updatedProgram}})
    this.programService.storeProgramDates(true)
  }

  public async removeDay(evt, day) {
    evt.stopPropagation();
    const num_following = day.sessions.length;
    const subsequent_days = this.lane.sessions.length > day.day;
    if (!num_following && !subsequent_days) {
      const rect = evt.target.getBoundingClientRect()
      const data = { rect, title: 'Delete this day', dialog: this.dialog }
      const del = await openConfirmDeleteGetResult(data)
      if (!del) return
      day.sessions.forEach(session_id => delete this.lane.sessions_obj[session_id] )
      this.lane.sessions.splice(day.day - 1, 1)
      this.lane.days = this.lane.sessions.length
      await this.programService.upsertProgram(this.lane)
      this.programService.storeProgramDates(true)
    } else {
      const result = await this.openDialogGetResult(ConfirmProgramActionDialogComponent, {
        width: '480px', disableClose: true,
        data: { type: 'day', num_following, subsequent_days, lane: this.lane }
      })
      if (result && result['confirmed']) {
        day.sessions.forEach(session_id => delete this.lane.sessions_obj[session_id])
        this.lane.sessions.splice(day.day - 1, 1)
        await this.programService.upsertProgram(this.lane)
        this.programService.storeProgramDates(true)
      }
    }
  }

  public async sendEditSession(evt, session: Session) {
    if (evt.target.closest('.non-popup-trigger') || session.type !== 'session') return
    this.editSession.emit(session)
  }


  async addSession(type: SessionType) {
    const newProgram = JSON.parse(JSON.stringify(this.lane)) as Program
    const session = this.programService.initSession(newProgram, type)
    newProgram.sessions[newProgram.days - 1].sessions.push(session.id)
    newProgram.sessions_obj[session.id] = session
    this.justAddedSession = true
    await this.programService.upsertProgram(newProgram, {file:this._file, function:'addSession', data:{ lane: newProgram, type }})
   
    await sleepForMS(10) // focus on last session
    const myLane = document.getElementById(`lane${this.lane.id}`)
    const textareas = myLane.querySelectorAll('.focus_on_new')
    const input = textareas[textareas.length - 1]
    if (input) input['focus']()
    myLane.scrollTop = myLane.scrollHeight

    await sleepForMS(1000)
    this.justAddedSession = false
}

  async addBetween({ top, type }: { top: boolean; type: SessionType; }, day_idx: number, sess_idx: number) {
    this.justAddedSession = true
    console.log({ top, type, day_idx, sess_idx })
    if (!top) sess_idx++
    const updatedProgram = JSON.parse(JSON.stringify(this.lane)) as Program
    const session = this.programService.initSession(updatedProgram, type)
    updatedProgram.sessions[day_idx].sessions.splice(sess_idx, 0, session.id);
    updatedProgram.sessions_obj[session.id] = session
    this.programService.upsertProgram(updatedProgram, { file:this._file, function:'addBetween', data: { top, type, day_idx, sess_idx }})

    await sleepForMS(10) // focus on added session
    const myTextarea = document.getElementById(`lane${this.lane.id}`)
      .querySelectorAll('.cards_container')[day_idx]
      .querySelectorAll('.focus_on_new')[sess_idx]
    myTextarea['focus']()

    await sleepForMS(1000)
    this.justAddedSession = false
  }


  async duplicateProgram() {
    this.loading.emit(true)
    try {
      const newProgramId = await this.programService.duplicateProgram(this.lane)
      this.programDuplicatedId.emit(newProgramId)
    } catch(error) { // error already logged in porgram service, why duplicate the error just because in duplicate function?
    } finally {
      this.loading.emit(false)
    }
  }

  public async deleteProgram() {
    // todo: this hack might have broke some old code that stopped duplicates swapping when a program is deleted
    const rect = document.getElementById(`${this.lane.id}Menu`).getBoundingClientRect()
    const data = { rect, title: 'Delete this room/location', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.programService.deleteProgram(this.lane.id)
    this.programDeleted.emit()
  }

  trackByProgramDay(index, item: ProgramDay) {
    return index
  }

  async drop(event: CdkDragDrop<ProgramLaneInitDayData>){
    console.log({ data: event.item.data, event })
    const dayIdx = event.container.data.day.day - 1 // this.lane.sessions.findIndex(d => d.day === event.item.data.day.day)
    console.log({dayIdx})
    const currProgram = jsonCopyObject(event.container.data.program)
    if(event.previousContainer === event.container) {
      moveItemInArray(currProgram.sessions[dayIdx].sessions, event.previousIndex, event.currentIndex)
    } else {
      const changedLanes = event.previousContainer.data.program.id !== event.container.data.program.id
      console.log({changedLanes})
      const prevProgram = changedLanes ? jsonCopyObject(event.previousContainer.data.program) : currProgram
      const prevDayIdx = event.previousContainer.data.day.day - 1
      transferArrayItem(
        prevProgram.sessions[prevDayIdx].sessions,
        currProgram.sessions[dayIdx].sessions,
        event.previousIndex,
        event.currentIndex,
      );
      // also move session object if moving between lanes
      if(changedLanes) {
        const sessionId = event.item.data.session.id
        const sessionObj = prevProgram.sessions_obj[sessionId]
        delete prevProgram.sessions_obj[sessionId]
        currProgram.sessions_obj[sessionId] = sessionObj
      }
      console.log({prevProgram, currProgram})
      console.log({prevProgram, currProgram})
      if(changedLanes) {
        await this.programService.upsertProgram(prevProgram, { file:this._file, function:'drop - prev', data: { event, program: prevProgram }})
      }
    }
    // moveItemInArray(updatedProgram.sessions[dayIdx].sessions, event.previousIndex, event.currentIndex)
    this.programService.upsertProgram(currProgram, { file:this._file, function:'drop - curr', data: { event, program: currProgram }})
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(event.previousContainer.data, event.previousIndex, event.currentIndex);
  //   } else {
  //     transferArrayItem(
  //       event.previousContainer.data,
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex,
  //     );
  //   }
  // }
}